import { render, staticRenderFns } from "./UploadCancelledChequeItem.vue?vue&type=template&id=784adb53&scoped=true&"
import script from "./UploadCancelledChequeItem.vue?vue&type=script&lang=js&"
export * from "./UploadCancelledChequeItem.vue?vue&type=script&lang=js&"
import style0 from "../../assets/style/base.css?vue&type=style&index=0&id=784adb53&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "784adb53",
  null
  
)

export default component.exports